/* eslint-disable eqeqeq */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import i18next from 'i18next';
import {
  ProductCarousel,
  trEnv,
  SepaLogo,
  ProduktStern,
  FormSelect,
  If,
  replaceEURinValueSet,
  FormMoney,
  toMoneyWOComma,
  FormRadio,
  Message,
  Headline,
  appActions,
  ProduktvergleichZahlweiseFormSelect,
  ProduktauswahlButton,
  ProduktvergleichBeratersuche,
  ProduktvergleichAngebotsdruck,
  SpeicherButton,
  useNextPage,
  PrevNextButton,
  useUpdateAndBerechneOnChange,
  useUpdateByNameAndBerechneOnChange,
  useUpdateAndValidateOnChange,
  useProduktBausteinHoehe,
  ProduktvergleichBeitrag,
  actions, istEnumAuswahl,
} from 'ion-lib';
import {
  Card, Col, Row, Form,
} from 'react-bootstrap';
import Leistungen from '../../components/Produktvergleich/Leistungen';
import ProduktHeader from '../../components/Produktvergleich/ProduktHeader';
import {
  Naturgefahr, Glasversicherung, Fahrraddiebstahl, Notfalldienste,
} from '../../components/Produktvergleich/Bausteine';
import Zusatzvereinbarung from '../../components/Produktvergleich/Bausteine/Zusatzvereinbarung';
import { istHausrat, setBeratersuche } from '../../helper';
import { EnumSb } from '../../components/enum';

const Produktvergleich = () => {
  const dispatch = useDispatch();
  const { bausteinHeadHeight } = useProduktBausteinHoehe();

  const bausteine = useSelector((state) => state.daten.bausteine);
  const auswahlBaustein = useSelector((state) => state.daten.auswahlBaustein);
  const laufzeit = useSelector((state) => state.daten.laufzeit);
  const sonderrabatt = useSelector((state) => state.daten.sonderrabatt);
  const versSumme = useSelector((state) => state.daten.versSumme);
  const tarifart = useSelector((state) => state.daten.tarifart);
  const versSummeAngepasst = useSelector((state) => state.daten.versSummeAngepasst);
  const wagnis = useSelector((state) => state.daten.wagnis);

  const berechneOnChange = useUpdateAndBerechneOnChange(0);
  const berechneOnChangeByName = useUpdateByNameAndBerechneOnChange(0);
  const berechneVSU = useUpdateByNameAndBerechneOnChange();
  const updateAndValidateOnChange = useUpdateAndValidateOnChange(0);
  const nextPage = useNextPage();
  const sterne = (id) => !trEnv.istOESA && <ProduktStern anzahl={id} />;

  /*
    Baut ein Array aus den Leistungen der Übersetzungsdatei.
    Im Array sind dann die Labels der Leistungen und die zugehörigen Texte der Tooltips.
    Dieses Array wird später an die <TooltipList> Komponente übergeben welches die Liste der
    Leistungen und die Tooltips rendert.
  */
  const leistungenListe = (produkt, leistungenType) => {
    const selector = `produktvergleich.${produkt.bezeichnung.value}.${leistungenType}`;
    const leistungen = i18next.exists(selector) && i18next.t(selector, {
      VSU: parseInt(versSumme.value, 10).toLocaleString('de-DE'),
      WERT: parseInt(produkt.wertsachenSumme.value, 10).toLocaleString('de-DE'),
      returnObjects: true,
    });

    return Object.keys(leistungen).map((key) => ({
      bezeichnung: leistungen[key],
      tooltipText: i18next.t([
        `${selector}Tooltips.${key}`,
        `produktvergleich.produkte.${key}`,
        '',
      ], {
        WERT: parseInt(produkt.wertsachenSumme.value, 10).toLocaleString('de-DE'),
        VSU: parseInt(versSumme.value, 10).toLocaleString('de-DE'),
        VSU_PROZENTSATZ: i18next.t(`produktvergleich.${produkt.bezeichnung.value}.vsu_prozentsatz`),
      }),
    }));
  };

  const bausteinId = parseInt(auswahlBaustein.value, 10);

  const handleNextClick = (deckungId) => {
    dispatch(actions.updateByName('daten.auswahlBaustein.value', deckungId));

    dispatch(appActions.serverValidationRequest('validiere', [
      `bausteine.${deckungId - 1}.glasversicherungArt`,
      `bausteine.${deckungId - 1}.vsuWertsachenAusreichend`,
      `bausteine.${deckungId - 1}.bruttoBeitrag`,
      'versSummeAngepasst',
    ], () => {
      nextPage();
    }));
  };

  const handleAngebotsdruck = (e, deck) => {
    e.preventDefault();
    dispatch(actions.updateByName('daten.auswahlBaustein.value', deck.id.value, () => {
      // validiere vor pdf druck, damit server ausgewählten baustein kennt
      dispatch(appActions.serverValidationRequest('validiere', [
        'auswahlBaustein',
      ], () => {
        dispatch(appActions.pdfRequest('erstelleAngebotDok', `${i18next.t('mandant')}_${deck.label.value}_Angebot.pdf`));
      }));
    }));
  };

  const filterTarife = () => bausteine.filter((elem) => elem.relevant.value);

  const getBausteinIndex = (element) => bausteine.findIndex((elem) => elem.id.value === element.id.value);
  const getFilterTarifeIndex = () => filterTarife().findIndex((elem) => parseInt(elem.id.value, 10) === bausteinId);

  const oesaProdukte = () => filterTarife().map((elem) => i18next.t(`produktvergleich.${elem.bezeichnung.value}.label`));

  const getSBAlert = (selbstbeteiligung) => {
    if (trEnv.istOESA
        && (istEnumAuswahl(selbstbeteiligung, EnumSb.TAU) || istEnumAuswahl(selbstbeteiligung, EnumSb.ZWEITAUFUENF))) {
      return i18next.t('produktvergleich.sb_1000_alert');
    }

    return null;
  };

  return (
    <>
      <Row className="sp-bg-trans">
        <Col>
          <Headline>
            {i18next.t('produktvergleich.headline')}
          </Headline>
          <Row>
            <Col>
              <ProductCarousel
                tarife={filterTarife()}
                label={oesaProdukte()}
                activeSlide={getFilterTarifeIndex()}
                sterne={sterne}
                nurSterne={!trEnv.istOESA}
                className="mb-3"
              >
                {filterTarife().map((baustein, bstIndex) => {
                  const hasBeitragError = !!baustein.bruttoBeitrag.error;
                  const isAuswaehlbar = !hasBeitragError;

                  return (
                    <div className="carousel-item" key={baustein.bezeichnung.value}>
                      <Card
                        className={`card--baustein card--${baustein.bezeichnung.value}
                          ${parseInt(baustein.id.value, 10) === bausteinId ? 'selected' : ''}
                        `}
                      >
                        <ProduktHeader
                          baustein={baustein}
                          deckungIndex={getBausteinIndex(baustein)}
                          height={bausteinHeadHeight}
                        />

                        <Leistungen
                          deck={baustein}
                          leistungenListe={leistungenListe}
                        />

                        <If predicate={baustein.vsuWertsachenAusreichend.relevant}>
                          <h4 className="zwischenheadline mb-3 mt-5 px-2">
                            Passen Sie Ihren Schutz an
                          </h4>

                          <Card.Body className="products__bausteine">
                            <If predicate={versSummeAngepasst.relevant}>
                              <FormMoney
                                {...versSummeAngepasst}
                                name="daten.versSummeAngepasst.value"
                                id={`daten.versSummeAngepasst.value[${bstIndex}]`}
                                label="Versicherungssumme anpassen?"
                                subtitle="Die richtige Versicherungssumme entspricht dem Neuwert des gesamten Hausrats."
                                value={versSummeAngepasst.value}
                                tooltip={() => dispatch(appActions.toggleModal(i18next.t('produktvergleich.produkte.vsu', {
                                  VSU_PROZENTSATZ: i18next.t(`produktvergleich.${baustein.bezeichnung.value}.vsu_prozentsatz`),
                                })))}
                                onChange={(name, value) => {
                                  berechneVSU(name, value);
                                }}
                                inputClassName="text-center"
                                inputGroup="€"
                                maxLenght={7}
                              />
                            </If>

                            <If predicate={baustein.vsuWertsachenAusreichend.relevant}>
                              <FormRadio
                                {...baustein.vsuWertsachenAusreichend}
                                name={`daten.bausteine.${getBausteinIndex(baustein)}.vsuWertsachenAusreichend.value`}
                                title={`Ist die Entschädigungsgrenze für Wertsachen von ${toMoneyWOComma(baustein.wertsachenSumme.value)} ausreichend?`}
                                tooltip={() => dispatch(appActions.toggleModal(i18next.t(`produktvergleich.${baustein.bezeichnung.value}.andereLeistungenTooltips.wertsachen`, {
                                  WERT: parseInt(baustein.wertsachenSumme.value, 10).toLocaleString('de-DE'),
                                })))}
                                onChange={updateAndValidateOnChange}
                              />
                            </If>
                          </Card.Body>
                        </If>

                        <If predicate={
                          baustein.naturgefahren.relevant
                          || baustein.glasversicherung.relevant
                          || baustein.notfalldienste.relevant
                          || baustein.fahrraddiebstahl.relevant
                          }
                        >
                          <h4 className={`zwischenheadline mb-3 mt-5 px-2 ${!trEnv.stationaer && bstIndex > 0 ? 'invisible-lg' : ''}`}>
                            Wählen Sie Ihren Zusatzschutz
                          </h4>

                          <Card.Body className="products__bausteine">
                            <Naturgefahr
                              baustein={baustein.naturgefahren}
                              bausteinIndex={getBausteinIndex(baustein)}
                              handleChange={(value) => berechneOnChangeByName(`daten.bausteine.${getBausteinIndex(baustein)}.naturgefahren.value`, value)}
                              handleChangeSelbstbehalt={berechneOnChange}
                              selbstbehalt={baustein.selbstbehaltElementar}
                            />

                            <Glasversicherung
                              baustein={baustein.glasversicherung}
                              glasart={baustein.glasversicherungArt}
                              bausteinIndex={getBausteinIndex(baustein)}
                              handleChange={(value) => berechneOnChangeByName(`daten.bausteine.${getBausteinIndex(baustein)}.glasversicherung.value`, value)}
                              handleChangeGlasArt={berechneOnChange}
                            />

                            <Notfalldienste
                              baustein={baustein.notfalldienste}
                              bausteinIndex={getBausteinIndex(baustein)}
                              handleChange={(value) => berechneOnChangeByName(`daten.bausteine.${getBausteinIndex(baustein)}.notfalldienste.value`, value)}
                            />

                            <Fahrraddiebstahl
                              baustein={baustein.fahrraddiebstahl}
                              bausteinIndex={getBausteinIndex(baustein)}
                              fahrradmax={baustein.fahrraddiebstahlWertMax}
                              fahrradwert={baustein.fahrraddiebstahlWert}
                              handleChange={(value) => berechneOnChangeByName(`daten.bausteine.${getBausteinIndex(baustein)}.fahrraddiebstahl.value`, value)}
                              handleChangeWert={berechneOnChangeByName}
                            />
                          </Card.Body>
                        </If>

                        <h4 className={`zwischenheadline mb-3 mt-5 px-2 ${!trEnv.stationaer && bstIndex > 0 ? 'invisible-lg' : ''}`}>
                          Konfigurieren Sie Ihr Produkt
                        </h4>

                        <Card.Body className="products__individual mb-auto">
                          <If predicate={baustein.selbstbeteiligung.relevant}>
                            <FormSelect
                              {...baustein.selbstbeteiligung}
                              valueSet={replaceEURinValueSet(baustein.selbstbeteiligung.valueSet)}
                              id="daten.selbstbeteiligung"
                              label="Selbstbeteiligung"
                              subtitle="Reduzieren Sie Ihren Beitrag!"
                              labelClassName="fb-100 text-start"
                              onChange={berechneOnChange}
                              name={`daten.bausteine.${getBausteinIndex(baustein)}.selbstbeteiligung.value`}
                              tooltip={() => dispatch(appActions.toggleModal(i18next.t('produktvergleich.sb_tt')))}
                              value={baustein.selbstbeteiligung.value}
                              flex
                            />
                            <If predicate={getSBAlert(baustein.selbstbeteiligung)}>
                              <Message
                                show
                                dismissible={false}
                                text={getSBAlert(baustein.selbstbeteiligung)}
                                variant="dark"
                              />
                            </If>
                          </If>

                          <If predicate={laufzeit.relevant}>
                            <FormSelect
                              {...laufzeit}
                              id="daten.laufzeit"
                              label="Vertragslaufzeit"
                              subtitle="Treue wird belohnt mit 10 % Dauerrabatt!"
                              labelClassName="fb-100 text-start"
                              onChange={berechneOnChange}
                              name="daten.laufzeit.value"
                              tooltip={() => dispatch(appActions.toggleModal(i18next.t('produktvergleich.laufzeit_tt')))}
                              value={laufzeit.value}
                              flex
                            />
                          </If>

                          <If predicate={trEnv.stationaer && parseInt(tarifart.value, 10) === 2 && !laufzeit.ueberschreibbar}>
                            <Message
                              show
                              dismissible={false}
                              className="mt-n2"
                              text={i18next.t('produktvergleich.laufzeit_alert')}
                              variant="dark"
                            />
                          </If>

                          <Zusatzvereinbarung
                            handleChange={berechneOnChangeByName}
                            nberabattWert={baustein.nberabattWert}
                          />

                          <If predicate={sonderrabatt.relevant}>
                            <FormSelect
                              {...sonderrabatt}
                              id="daten.sonderrabatt"
                              label="Besondere Vereinbarungen"
                              labelClassName="fb-100 text-start"
                              onChange={berechneOnChange}
                              name="daten.sonderrabatt.value"
                              tooltip={() => dispatch(appActions.toggleModal(i18next.t('produktvergleich.sonderrabatt_tt')))}
                              value={sonderrabatt.value}
                              flex
                            />
                          </If>

                          <ProduktvergleichZahlweiseFormSelect
                            id="daten.zahlweise"
                            handleSelect={berechneOnChange}
                            tooltipRight={false}
                            tooltip={() => dispatch(appActions.toggleModal(i18next.t('produktvergleich.zahlweise_tt')))}
                          />
                          {
                            hasBeitragError && (
                              <Form.Group className="form-group">
                                <Form.Control.Feedback
                                  type="invalid"
                                >
                                  {baustein.bruttoBeitrag.error}
                                </Form.Control.Feedback>
                              </Form.Group>
                            )
                          }

                          <div className="d-flex flex-column mt-auto">
                            <hr className="hr--light-gray sp-w-100 mt-2 mb-3" />

                            <ProduktvergleichBeitrag beitrag={istHausrat() ? baustein.bruttoBeitrag : baustein.bruttoBeitragGlas} />

                            <ProduktauswahlButton
                              tracking={baustein.bezeichnung.value.toLowerCase()}
                              buttonText="Jetzt abschließen"
                              handleClick={() => handleNextClick(baustein.id.value)}
                              disabled={!isAuswaehlbar}
                            />

                            <ProduktvergleichBeratersuche href={setBeratersuche('beratersuche', wagnis)} deck={baustein.label.value.toLowerCase()} />

                            <SpeicherButton size="sm" className="mt-4" />

                            <ProduktvergleichAngebotsdruck
                              deck={baustein.label.value.toLowerCase()}
                              handleClick={(e) => handleAngebotsdruck(e, baustein)}
                            />

                          </div>
                        </Card.Body>
                      </Card>
                    </div>
                  );
                })}
              </ProductCarousel>

            </Col>
          </Row>

          <Row>
            <Col>
              <div className="sp-bg-white">
                <h4>Sie wollen es ganz genau wissen?</h4>
                {istHausrat()
                  ? (
                    <p>
                      Hier finden Sie das
                      {' '}
                      <span
                        className="inline-fix"
                        dangerouslySetInnerHTML={{
                          __html: i18next.t('produktvergleich.links.infoBlatt'),
                        }}
                      />
                      , die&nbsp;
                      <span
                        className="inline-fix"
                        dangerouslySetInnerHTML={{
                          __html: i18next.t('produktvergleich.links.versBedingungen'),
                        }}
                      />
                      , das&nbsp;
                      <span
                        className="inline-fix"
                        dangerouslySetInnerHTML={{
                          __html: i18next.t('produktvergleich.links.infoBlattGlas'),
                        }}
                      />
                      {' '}
                      und die&nbsp;
                      <span
                        className="inline-fix"
                        dangerouslySetInnerHTML={{
                          __html: i18next.t('produktvergleich.links.versBedingungenGlas'),
                        }}
                      />
                      .
                    </p>
                  )
                  : (
                    <p>
                      Hier finden Sie das
                      {' '}
                      <span
                        className="inline-fix"
                        dangerouslySetInnerHTML={{
                          __html: i18next.t('produktvergleich.links.infoBlattGlas'),
                        }}
                      />
                      {' '}
                      und die&nbsp;
                      <span
                        className="inline-fix"
                        dangerouslySetInnerHTML={{
                          __html: i18next.t('produktvergleich.links.versBedingungenGlas'),
                        }}
                      />
                      .
                    </p>
                  )}
              </div>
              <SepaLogo />
            </Col>
          </Row>

        </Col>
      </Row>
      <Row>
        <Col>
          <PrevNextButton
            className="d-md-none oev-show spk-show"
          />
        </Col>
      </Row>
    </>
  );
};

export default Produktvergleich;
